
export default function (toaster) {
'ngInject';
    return {
        popUp(type, title, body) {
            toaster.clear();
            toaster.pop({
                type: type,
                title: title,
                body: body
            })
        },
        error() {
            toaster.clear();
            toaster.pop({
                type: 'error',
                title: 'Error',
                body: 'Se ha producido un error en el servidor.'
            })
        }
    }

}


// WEBPACK FOOTER //
// ./client/components/util/toaster.service.js